import { FiChevronDown } from 'react-icons/fi'

import { type GeofenceFilterValue, useTrackerMapContext } from '../TrackerMapContext'

const options: { value: GeofenceFilterValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'inside', label: 'Inside' },
  { value: 'outside', label: 'Outside' },
]

// NOTE: no-op for now — trackers don't carry geofence membership yet, so this only stores the
// selection. TODO: filter the tracker list once the API reports in-geofence state.
export const GeofenceFilter = () => {
  const { filters, setFilters } = useTrackerMapContext()

  const handleChange = (value: GeofenceFilterValue) => setFilters({ ...filters, geofence: value })
  const currentLabel = options.find((o) => o.value === filters.geofence)?.label ?? 'All'

  return (
    <div className="dropdown" data-filter-dropdown>
      <div
        tabIndex={0}
        role="button"
        className="btn btn-sm btn-outline min-w-[160px] flex items-center justify-between font-normal"
      >
        <span>In Geofence: {currentLabel}</span>
        <FiChevronDown className="w-4 h-4 text-base-content/60" />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-lg shadow-lg border border-base-300 z-20 w-full p-1 mt-1"
      >
        {options.map((opt) => (
          <li key={opt.value}>
            <button
              onClick={() => handleChange(opt.value)}
              className={`text-xs ${filters.geofence === opt.value ? 'active' : ''}`}
            >
              In Geofence: {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
